export const getTimeToInteract = (): number => {
  try {
    const entries = window.performance.getEntriesByType('navigation');
    // @ts-expect-error
    return Math.round(entries[0].domInteractive);
  } catch (err: any) {
    // hitting circular dependency to log anything here
    return 0;
  }
};

export const getPageLoadTime = (): number => {
  const time = window?.performance?.timing;
  const loadEventEnd = time?.loadEventEnd || time?.loadEventStart;
  // send the difference only when time is available
  // tt - The whole process of navigation and page load
  return time ? loadEventEnd - time.navigationStart : 0;
};

export interface CPLDeviceNetworkInfo {
  /** Approximate amount of device memory in gigabytes. */
  readonly device_memory?: number;
  /**
   * Approximate bandwidth of the client's connection to the server in Mbps
   */
  readonly network_downlink?: number;
  /** Maximum downlink speed in Mbps for the underlying connection. */
  readonly network_downlinkMax?: number;
  /**
   * determined using observed round-trip times and downlink values
   */
  readonly network_effectiveType?: 'slow-2g' | '2g' | '3g' | '4g';
  /** Approximate round trip time on the application layer, in mills. */
  readonly network_roundTripTime?: number;
  /** User has set a reduced data usage option on the user agent. */
  readonly network_saveData?: boolean;
  /** connection a device is using to communicate with the network. */
  readonly network_type?: unknown;
  /**
   * Interior height of the window in pixels,
   * including the height of the horizontal scroll bar, if present.
   */
  readonly screen_height?: number;
  /**
   * Interior width of the window in pixels.
   * This includes the width of the vertical scroll bar, if one is present.
   */
  readonly screen_width?: number;
}

export const getDeviceAndNetworkInfo = (): CPLDeviceNetworkInfo => {
  // @ts-expect-error (experimental feature not in TS yet)
  const netInfo = window?.navigator?.connection;
  // Adding prefix's for 'network_', 'device_', 'screen_'
  return {
    // @ts-expect-error (experimental feature not in TS yet)
    device_memory: window?.navigator?.deviceMemory,
    network_downlink: netInfo?.downlink,
    network_downlinkMax: netInfo?.downlinkMax,
    network_effectiveType: netInfo?.effectiveType,
    network_roundTripTime: netInfo?.rtt,
    network_saveData: netInfo?.saveData,
    network_type: netInfo?.type,
    screen_height:
      window?.innerHeight || document?.documentElement?.clientHeight, // fallback to clientHeight to support ie, quirks
    screen_width: window?.innerWidth || document?.documentElement?.clientWidth, // fallback to clientWidth to support ie, quirks
  };
};
